import React, { useEffect, useState } from "react";
import axios from "axios";
import '../../Admin1/Pages/admin1.css';
import Loader from '../../../safreeimg/loader.gif';

const PlanManagement = () => {
  const [selectedPlan, setSelectedPlan] = useState('');
  const [selectedPlanDetails, setSelectedPlanDetails] = useState('');
  const [planData, setPlanData] = useState(null);
  const [loading, setLoading] = useState(true);

  const [showModal, setShowModal] = useState(false);
  const [autoRenew, setAutoRenew] = useState('enable');
  const [quantity, setQuantity] = useState(5);
  const [subscriptionId, setSubscriptionId] = useState('');
  const [stripeSubscriptionId, setStripeSubscriptionId] = useState('');

  const maxQuantity = 10000;
  const quantityOptions = Array.from({ length: maxQuantity / 5 }, (_, index) => (index + 1) * 5);

  const [showUpdateModal, setShowUpdateModal] = useState(false);
  const [updateQuantity, setUpdateQuantity] = useState(5);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const fetchPlan = async () => {
    try {
      const token = localStorage.getItem('token');
      const response = await axios.get(
        'https://api.safree.org/api-v2022/organization/auth/v1/current-plan',
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      const data = response.data.data;
      setPlanData(data);

      const currentPlan = data.subscriptionType.toLowerCase();
      setSelectedPlan(currentPlan === 'basic' ? 'freemium' : currentPlan);

      if (data.premium) {
        setSubscriptionId(data.premium.subscriptionId);
        setStripeSubscriptionId(data.premium.stripeSubscriptionId);
      }

      setSelectedPlanDetails(
        `This is the ${data.subscriptionType} plan. Amount: ${data[data.subscriptionType.toLowerCase()].amount}, Validity: ${data[data.subscriptionType.toLowerCase()].validity} days`
      );
    } catch (err) {
      console.error("API fetch failed:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchPlan();
  }, []);

  const handleViewDetails = (planType) => {
  setSelectedPlan(planType);
  const plan = planData[planType];

  if (planType === 'freemium') {
    setSelectedPlanDetails([
      `This is the ${planType} plan.`,
      `Amount: ${plan.amount}`,
      `Validity: ${plan.validity} days`,
      `Features:`,
      `Only 3 chances for SOS functionality`,
      `Only 1 guardian can be added`,
      `Standard Keywords`,
      `No sound recording`,
      `No chat function for Guardians`,
      `Guardians cannot see each other`,
      `Location accuracy: ${plan.locationAccuracy ? 'Yes' : 'No'}`
    ]);
  } else if (planType === 'premium') {
    setSelectedPlanDetails([
      `This is the ${planType} plan.`,
      `Amount: ${plan.amount}`,
      `Validity: ${plan.validity} days`,
      `Admin Features:`,
      `Admin can access all customer alarms`,
      `Admin can manage users (Add, Edit, Delete, Update)`,
      `Admin can create Guardians and assign them to groups`,
      `Admin can raise alarms on behalf of users and guardians get notified`,
      `Admin can access real-time location of all users`,
      `Admin can send manual notifications to users`,
      `Admin can access all previous alarms raised with timestamps and data`,
      `Admin has access to all alarm recordings of users for a specific amount of time`,
      `Live chat between Admin and customers`
    ]);
  } else {
    setSelectedPlanDetails([
      `This is the ${planType} plan.`,
      `Amount: ${plan.amount}`,
      `Validity: ${plan.validity} days`
    ]);
  }
};


  const handlePurchaseClick = () => setShowModal(true);

  const handleSubmitPurchase = async () => {
    try {
      const token = localStorage.getItem('token');
      const response = await axios.post(
        'https://api.safree.org/api-v2022/stripe/v1/purchase/organization/subscription',
        {
          subscriptionId,
          autorenew: autoRenew,
          quantity
        },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      if (response.status === 200) {
        alert('Continew to Purchase');
        window.open(response.data.data, "_blank");
        setShowModal(false);
      }
    } catch (error) {
      console.error("Error during purchase:", error);
      alert('Error during purchase');
    }
  };

  const handleSubmitUpdate = async () => {
    try {
      setIsSubmitting(true);
      const token = localStorage.getItem('token');
      const response = await axios.post(
        'https://api.safree.org/api-v2022/stripe/v1/update/organization/subscription',
        {
          subscriptionId: stripeSubscriptionId,
          quantity: updateQuantity
        },
        {
          headers: { Authorization: `Bearer ${token}` }
        }
      );

      if (response.status === 200) {
        alert("Subscription updated successfully!");
        setShowUpdateModal(false);
        window.location.reload();
      }
    } catch (error) {
      console.error("Error during update:", error);
      alert("Error updating subscription");
    } finally {
      setIsSubmitting(false); // Stop loading after request finishes
    }
  };

  if (loading) return <div className="loading"><img src={Loader} alt="" /></div>;
  if (!planData) return <div>Error loading plans</div>;

  return (
    <div className="choose-plan-container">
      <div className="row header hdfgb">
        <div className="col-md-12">
          <p className="sub-heading">Choose Your Subscription Plan</p>
        </div>
      </div>

      <div className="plans-wrapper side-by-side">
        {/* Freemium Plan */}
        <div className={`plan-card gradient-orange ${selectedPlan === 'freemium' ? 'active' : ''}`} >
          <div className="plan-top">
            <span className="plan-label">Freemium</span>
            {planData.subscriptionType === 'Freemium' && <span className="current-badge">Current Plan</span>}
          </div>
          <div className="plan-content">
            <p><strong>Expiry Date:</strong> {planData.freemium.expiryDate}</p>
            <p><strong>Auto Renew:</strong> <span className="green-text">{planData.freemium.autoRenew}</span></p>
          </div>
          <div className="view-link" onClick={() => handleViewDetails('freemium')}>View Details →</div>
        </div>

        {/* Premium Plan */}
        <div className={`plan-card gradient-orange ${selectedPlan === 'premium' ? 'active' : ''}`} >
          <div className="plan-top">
            <span className="plan-label">Premium</span>
            {planData.subscriptionType === 'Premium' && <span className="current-badge">Current Plan</span>}
          </div>
          <div className="plan-content">
            <p><strong>Expiry Date:</strong> {planData.premium.expiryDate}</p>
            <p><strong>Auto Renew:</strong> <span className="green-text">{planData.premium.autoRenew}</span><strong style={{ paddingLeft: '13px' }}>Users:</strong> {planData.premium.subscriptionUsers}</p>
            <p></p>
            <div className="price-info">
              <span className="price">€ {planData.premium.amount}</span>
              <span className="month">/ Month</span>
            </div>
            <button
              onClick={() => setShowUpdateModal(true)}
              className="update-btn"
              disabled={planData.subscriptionType.toLowerCase() !== 'premium'}
              style={{
                opacity: planData.subscriptionType.toLowerCase() !== 'premium' ? 0.6 : 1,
                cursor: planData.subscriptionType.toLowerCase() !== 'premium' ? 'not-allowed' : 'pointer',
              }}
            >
              Update
            </button>

          </div>
          <div className="view-link" onClick={() => handleViewDetails('premium')}>View Details →</div>
        </div>
      </div>

      <button
        className="purchase-btn"
        onClick={handlePurchaseClick}
        disabled={planData.subscriptionType.toLowerCase() === 'premium'}
        style={{
          opacity: planData.subscriptionType.toLowerCase() === 'premium' ? 0.6 : 1,
          cursor: planData.subscriptionType.toLowerCase() === 'premium' ? 'not-allowed' : 'pointer',
        }}
      >
        Continue To Purchase
      </button>

      {Array.isArray(selectedPlanDetails) && selectedPlanDetails.length > 0 && (
  <div className="plan-details-text">
    <ul>
      {selectedPlanDetails.map((item, index) => (
        <li key={index}>{item}</li>
      ))}
    </ul>
  </div>
)}


      {/* Purchase Modal */}
      {showModal && (
        <div className="modal-overlay">
          <div className="modal-content">
            <h3>Confirm Purchase</h3>
            <div>
              <label>Auto Renew</label>
              <select value={autoRenew} onChange={(e) => setAutoRenew(e.target.value)}>
                <option value="enable">Enable</option>
                <option value="disable">Disable</option>
              </select>
            </div>
            <div>
              <label>Quantity</label>
              <select value={quantity} onChange={(e) => setQuantity(Number(e.target.value))}>
                {quantityOptions.map((value) => (
                  <option key={value} value={value}>{value}</option>
                ))}
              </select>
            </div>
            <div className="modal-actions">
              <button onClick={handleSubmitPurchase}>Confirm Purchase</button>
              <button onClick={() => setShowModal(false)}>Cancel</button>
            </div>
          </div>
        </div>
      )}

      {/* Update Modal */}
      {showUpdateModal && (
        <div className="modal-overlay">
          <div className="modal-content">
            <h3>Update Subscription</h3>
            <div>
              <label>Quantity</label>
              <select value={updateQuantity} onChange={(e) => setUpdateQuantity(Number(e.target.value))}>
                {quantityOptions.map((value) => (
                  <option key={value} value={value}>{value}</option>
                ))}
              </select>
            </div>
            <div className="modal-actions">
              <button onClick={handleSubmitUpdate}>
                {isSubmitting ? (
                  <div className="spinner-border text-light" style={{ width: '20px', height: '20px' }} role="status">
                  </div>
                ) : (
                  'Confirm Update'
                )}
              </button>
              <button onClick={() => setShowUpdateModal(false)}>Cancel</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default PlanManagement;
